import type { EventEmitter } from "eventemitter3";
import { useEffect } from "react";

/**
 * To remove boilerplate, especially for when
 * we need to cleanup event subscriptions (because of HMR)
 */
export function useEvent<
  EventTypes extends EventEmitter.ValidEventTypes,
  EventKey extends EventEmitter.EventNames<EventTypes>
>(
  emitter: EventEmitter<EventTypes>,
  eventKey: EventKey,
  callback: EventEmitter.EventListener<EventTypes, EventKey>,
  effectDependencies: any[] = []
) {
  useEffect(() => {
    emitter.on(eventKey, callback);

    return () => {
      emitter.off(eventKey, callback);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emitter, callback, eventKey, ...effectDependencies]);
}
